<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="d-flex align-items-start my-2">
          <label class="me-5 w-25" for="maxTemp">輸入文字1</label>
          <el-input v-model="customText[0]" />
        </div>
        <div class="d-flex align-items-start my-2">
          <label class="me-5 w-25" for="maxTemp">輸入文字2</label>
          <el-input v-model="customText[1]" />
        </div>
        <div class="d-flex align-items-start my-2">
          <label class="me-5 w-25" for="maxTemp">輸入文字3</label>
          <el-input v-model="customText[2]" />
        </div>
        <div class="d-flex align-items-start my-2">
          <label class="me-5 w-25" for="maxTemp">輸入文字4</label>
          <el-input v-model="customText[3]" />
        </div>
        <div class="d-flex align-items-start my-2">
          <label class="me-5 w-25" for="maxTemp">輸入文字5</label>
          <el-input v-model="customText[4]" />
        </div>
      </div>
      <div class="col-6">
        <div>
          <label class="me-3" for="color">背景色</label>
          <el-color-picker color-format="rgb" v-model="bgColor" />
        </div>
        <div>
          <h5 class="py-3">選擇圖片</h5>
          <el-select v-model="imageFileName" class="m-2" placeholder="Select" id="modeVertical">
            <el-option v-for="item in bgImages" :key="item.value" :label="item.label"
                       :value="item.value" />
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <WaterMarkImage
            v-model:water-mark-image-file-name="waterMarkImageFileName"
            v-model:wm-opacity="wmOpacity"
            v-model:wm-shadow="wmShadow"
            v-model:wm-horizontal="wmHorizontal"
            v-model:wm-vertical="wmVertical"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary mx-2" @click.stop="handleSubmit">確認</button>
        <button type="button" class="btn btn-secondary mx-2" @click.stop="handleInit">清空</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import WaterMarkImage from "@/components/controllerMode/comp/WaterMarkImageComp.vue";

import defaultValue from "@/utils/defaultValue";
import ColorTool from "@/utils/colorTool";

import freeImg from "@/utils/freeImg";

const {
  bgImages,
  watermarkImages
} = freeImg()

const {
  textMode,
} = defaultValue()

const {getRgbFilterString} = ColorTool()

const emit = defineEmits(['getTempControlData'])
const props = defineProps(['effectName'])
const tempControlData = reactive({
  Theme: {},
  Text: {},
  Watermark: {}
})

const textModeValue = ref('None')

const customText = ref([
    '輸入文字1',
    'ABCDE',
    '@#$%^&',
    'abcde',
    '1234567',
])

const bgColor = ref('rgb(0,0,0)')


// todo use mixins
const limitTextarea = () => {
  const maxLength = 5  // 一行最多的中文字數
  const lines = customText.value.split('\n') //將輸入內容轉成陣列處理
  const lastLine = lines.pop()// 取得最新輸入的值
  customText.value = lines.concat([lastLine.slice(0, maxLength)]).join('\n')

  // const maxLength = 5  // 一行最多的中文字數
  // const maxRows = 10  // 最多的行數
  // const lines = customText.value.split('\n') //將輸入內容轉成陣列處理
  // const lastLine = lines.pop()// 取得最新輸入的值
  // const lineCount = lines.length + 1
  // if (lineCount > maxRows) {
  //   customText.value = lines.join('\n')
  //   return
  // }
  // customText.value = lines.concat([lastLine.slice(0, maxLength)]).join('\n')
  // if (lastLine.length > maxLength) customText.value = lines.concat([lastLine.slice(0, maxLength)]).join('\n');//只要超過一律無情剪斷
}


const imageFileName = ref('')


/////浮水印控制/////

const wmOpacity = ref(50)
const wmHorizontal = ref(50)
const wmVertical = ref(50)
const wmShadow = ref(50)

const waterMarkImageFileName = ref('')


const speed = ref(4)
function handleSubmit () {
  let BackgroundColor = []
  if (bgColor.value.indexOf('rgb(') >= 0) BackgroundColor = getRgbFilterString(bgColor.value)

  Object.assign(tempControlData.Theme, {
    Effect: props.effectName,
    IsDynamicMode: false,
    Colors: [],
    Speed: speed.value,
    BackgroundColor: BackgroundColor,
    AnimateText: customText.value,
    HasBackgroundImage: imageFileName.value !== null && imageFileName.value !== '',
    BackgroundImage: imageFileName.value
  })
  Object.assign(tempControlData.Text, {
    Type: textModeValue.value
  })


  // 浮水印
  Object.assign(tempControlData.Watermark, {
    "HasImage": waterMarkImageFileName.value !== '',
    "Image": waterMarkImageFileName.value !== '' ? waterMarkImageFileName.value : '',
    "Horizontal": wmHorizontal.value,
    "Vertical": wmVertical.value,
    "Shadow": wmShadow.value,
    "Opacity": wmOpacity.value
  })

  emit('getTempControlData', tempControlData)

}

function handleInit () {

}

</script>
